import React from 'react';
import { StyleSheet, Platform, View } from 'react-native';

type Props = {};

type BorderStyle = 'solid' | 'dotted' | 'dashed';

const Line: React.FC<Props> = (props: Record<string, any>) => {
  const styles = createStyles(props);
  const { height } = props;

  return (
    <View style={{ height: height, overflow: 'hidden' }}>
      <View style={styles.container}></View>
    </View>
  );
};

const createStyles = (props: Record<string, any>) => {
  const borderStyle = props?.attributes?.borderStyle || props.borderStyle;
  const { height } = props;
  const backgroundColor =
    props?.attributes?.backgroundColor || props.backgroundColor;

  return StyleSheet.create({
    container: {
      width: borderStyle !== 'none' ? props.width : 0,
      height,
      ...(borderStyle !== 'none'
        ? {
            borderStyle: borderStyle as BorderStyle,
            borderColor: backgroundColor,
          }
        : { borderWidth: 0 }),
      ...Platform.select({
        ios: {
          borderWidth: height,
          borderRadius: 1,
          marginTop: -height / 2,
          marginLeft: -height / 2,
          marginRight: -height / 2,
        },
        android: {
          borderWidth: height,
          borderRadius: 1,
          marginTop: -height / 2,
          marginLeft: -height / 2,
          marginRight: -height / 2,
        },
        default: {
          borderTopWidth: height,
        },
      }),
    },
  });
};

export default Line;
